import React, { useEffect } from 'react';
import Modal from '@mui/material/Modal';
import propTypes from 'prop-types';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import { StyledButton } from '../../../../../Components/Generics.styled';
import Autocomplete from '@mui/material/Autocomplete';

const NavigationSection = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const StyledTextField = styled(TextField)`
    width: 350px;
`;

const LoginTextFieldContainer = styled.div`
    display: flex;
    width: 900px;
    flex-direction: column;
    justify-content: center;
    margin-top: 25px;
    margin-left: auto;
    margin-right: auto;
`;

const RowContainer = styled.div`
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: row;
    width: 900px;
    justify-content: space-evenly;
`;

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    width: 1100,
    padding: 23,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const EditAccountInfoModal = (props) => {
    const {
        modalIsOpen,
        setModalIsOpen,
        postAccountData,
        productData,
        handlePlanTypeChange,
        currentPlanType,
        setCurrentPlanMetaData,
        handleSave,
        setProfile,
        mutateProfile,
        profile,
    } = props;

    const { advertiser } = { ...profile };

    const { planTypeName, planTypeId, isBilledAnnually } = {
        ...advertiser,
    };

    const currentSubscription = {
        planTypeName,
        planTypeId,
        duration: isBilledAnnually ? 'Annually' : 'Monthly',
    };

    const resetFields = () => {
        mutateProfile();
        setProfile({
            ...profile,
        });
        setCurrentPlanMetaData();
    };

    useEffect(() => {
        resetFields();
    }, [modalIsOpen]);

    const handleClose = () => {
        resetFields();
        setModalIsOpen(false);
    };

    const disableCurrentSubscription = (option) => {
        if (
            option.planTypeId === currentSubscription.planTypeId &&
            option.duration === currentSubscription.duration
        ) {
            return true;
        } else return false;
    };

    const disableNextButton =
        profile?.firstName === '' || profile?.lastName === '' || profile?.phoneNumber === '';

    const body = (
        <div style={style}>
            <LoginTextFieldContainer>
                <RowContainer>
                    <h1>Update Account</h1>
                </RowContainer>
                <br />
                <RowContainer>
                    <StyledTextField
                        id="first-name"
                        label="First Name"
                        defaultValue={profile?.firstName}
                        onChange={(e) =>
                            setProfile({
                                ...profile,
                                firstName: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={profile?.firstName === ''}
                    />
                    <StyledTextField
                        id="last-name"
                        label="Last Name"
                        defaultValue={profile?.lastName}
                        onChange={(e) =>
                            setProfile({
                                ...profile,
                                lastName: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={profile?.lastName === ''}
                    />
                </RowContainer>

                <br />
                <RowContainer>
                    <StyledTextField
                        id="primary-phone"
                        label="Primary Phone"
                        defaultValue={profile?.phoneNumber}
                        onChange={(e) =>
                            setProfile({
                                ...profile,
                                phoneNumber: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={profile?.phoneNumber === ''}
                    />
                    <StyledTextField
                        id="email-address"
                        label="Email Address"
                        defaultValue={profile?.email}
                        onChange={(e) =>
                            setProfile({
                                ...profile,
                                email: e.target.value,
                            })
                        }
                        disabled
                        variant="outlined"
                        error={profile?.email === ''}
                    />
                </RowContainer>
                <br />
                <RowContainer style={{ width: '770px', justifyContent: 'left' }}>
                    <Autocomplete
                        disablePortal
                        disableClearable
                        getOptionDisabled={(option) => disableCurrentSubscription(option)}
                        id="combo-box-demo"
                        options={productData || []}
                        value={currentPlanType}
                        getOptionLabel={(option) =>
                            `${option.name} - $${option.fee}/${option.duration} ${
                                option.current ? '(Current)' : ''
                            }`
                        }
                        onChange={(e, value) => handlePlanTypeChange(e, value)}
                        sx={{ width: '100%' }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Select Subscription"
                                label="Select Subscription"
                            />
                        )}
                    />
                </RowContainer>
                <br />
            </LoginTextFieldContainer>
            <br />
            <br />
            {/* <div>{postAccountData?.error?.reason}</div> */}

            <NavigationSection>
                <StyledButton onClick={() => handleClose()} variant="contained" color="primary">
                    Cancel
                </StyledButton>
                <StyledButton
                    disabled={disableNextButton}
                    onClick={() => handleSave()}
                    variant="contained"
                    color="primary"
                >
                    {postAccountData.isLoading ? (
                        <CircularProgress
                            style={{ height: '20px', width: '20px', color: 'white' }}
                            color="primary"
                        />
                    ) : (
                        'Save'
                    )}
                </StyledButton>
            </NavigationSection>

            <EditAccountInfoModal currentPlanType={currentPlanType} />
        </div>
    );

    return (
        <div>
            <Modal
                open={modalIsOpen}
                onClose={() => handleClose()}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
};

EditAccountInfoModal.propTypes = {
    modalIsOpen: propTypes.bool,
    setModalIsOpen: propTypes.func,
    postAccountData: propTypes.shape({ isLoading: propTypes.bool }),
    productData: propTypes.array,
    handlePlanTypeChange: propTypes.func,
    currentPlanType: propTypes.shape({ planTypeId: propTypes.number }),
    setCurrentPlanMetaData: propTypes.func,
    handleSave: propTypes.func,
    setProfile: propTypes.func,
    profile: propTypes.shape({
        firstName: propTypes.string,
        lastName: propTypes.string,
        email: propTypes.string,
        phoneNumber: propTypes.string,
    }),
    mutateProfile: propTypes.func,
};

EditAccountInfoModal.defaultProps = {
    modalIsOpen: false,
    setModalIsOpen: () => {},
    postAccountData: {},
    productData: [],
    handlePlanTypeChange: () => {},
    currentPlanType: {},
    setCurrentPlanMetaData: () => {},
    handleSave: () => {},
    setProfile: () => {},
    profile: {},
    mutateProfile: () => {},
};
export default EditAccountInfoModal;
